'use client'

import { forwardRef, useImperativeHandle, useRef, VideoHTMLAttributes } from 'react'

export type IVideoProps = VideoHTMLAttributes<HTMLVideoElement>

export const Video = forwardRef<HTMLVideoElement, IVideoProps>(function Video(props, ref) {
    const videoRef = useRef<HTMLVideoElement>(null)

    useImperativeHandle(ref, () => videoRef.current!, [])

    return (
        <video
            ref={videoRef}
            crossOrigin="anonymous"
            {...props}
            controlsList="nodownload noplaybackrate nofullscreen"
            disablePictureInPicture={true}
            onContextMenu={(e) => e.preventDefault()}
        />
    )
})

export const setVideoVolume = (videoElement: HTMLVideoElement | null, localVolume: number) => {
    if (!videoElement) return
    videoElement.volume = localVolume
}
